/**
 * The tool interaction mode defines which camera controls are available while the tool is running.
 **/
export const InteractionMode = {
    /**
     * The tool is performing no interactions.
     * Camera controls is available while tool is running.
     **/
    None: 0,
    /**
     * The tool is performing primary interactions (left mouse button, one finger touch).
     * Only secondary camera controls are possible.
     **/
    Primary: 1,
    /**
     * The tool is performing primary and secondary interactions.
     * Camera controls are completely disabled.
     **/
    All: 2
};
